import { render, staticRenderFns } from "./BlackFridayIcon.vue?vue&type=template&id=78e66703"
import script from "./BlackFridayIcon.vue?vue&type=script&lang=js"
export * from "./BlackFridayIcon.vue?vue&type=script&lang=js"
import style0 from "./BlackFridayIcon.vue?vue&type=style&index=0&id=78e66703&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports